import React, { useState } from "react";
import { Select, Pagination } from "antd";
import { toast } from "react-toastify";
import SearchFilter from "../../SearchFilter";
import TopicNameDataTable from "./TopicNameDataTable"; // You will need to copy SubCategoryDataTable and rename it too
import { useQuery, useQueryClient } from "react-query";
import useAxiosInstance from "../../../lib/useAxiosInstance";

const TopicNameList = () => {
  const axiosInstance = useAxiosInstance();
  const queryClient = useQueryClient();

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [searchKeyword, setSearchKeyword] = useState("");

  const fetchTopics = async () => {
    let response;
    if (searchKeyword) {
      response = await axiosInstance.get(
        `api/category/search/topic?keyword=${searchKeyword}&size=${limit}&page=${currentPage}`
      );
    } else {
      response = await axiosInstance.get(
        `api/category/topic?size=${limit}&page=${currentPage}`
      );
    }
    setTotal(response?.data?.data?.data?.totalCategories);
    return response;
  };

  const topicData = useQuery(
    ["topics", currentPage, limit, searchKeyword],
    fetchTopics,
    {
      refetchOnWindowFocus: false,
      retry: 1
    }
  );


  const handleDelete = async (record) => {
    try {
      await axiosInstance.delete(`api/category/${record._id}`);
      toast.success("Topic deleted successfully");
      queryClient.invalidateQueries("topics");
    } catch (error) {
      toast.error("Something went wrong while deleting topic");
    }
  };

  const pagination = {
    total: total * limit,
    pageSize: limit,
    current: currentPage,
    onChange: (page, size) => {
      setCurrentPage(page);
      setLimit(size);
    }
  };

  return (
    <div className='gms-page-section'>
      <div className='gms-table-wrapper table-wrap'>
        <SearchFilter handleSearch={(value) => {
          setCurrentPage(1);
          setSearchKeyword(value);
        }} />

        <TopicNameDataTable
          topicData={topicData?.data?.data?.data}
          pagination={pagination}
          handleDelete={handleDelete}
          isLoading={topicData?.isLoading}
        />

        <div className='report-pagination '>
          <div>
            <Select
              value={limit.toString()}
              style={{ width: 56 }}
              onChange={(val) => {
                setLimit(parseInt(val));
                setCurrentPage(1);
              }}
              options={["10", "20", "50", "100"].map(v => ({ value: v, label: v }))}
            />
            <span className='ml-3'> Entries Per Page</span>
          </div>
          <Pagination
            className='pagination'
            {...pagination}
          />
        </div>
      </div>
    </div>
  );
};

export default TopicNameList;